document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("newsletterForm");
    if (!form) {
        return;
    }

    const submitBtn = document.getElementById("newsletterSubmitBtn");
    const consentCheckbox = document.getElementById("newsletterConsent");
    const emailInput = form.querySelector('input[type="email"]');
    const closeBtn = document.getElementById("newsletterSuccessCloseBtn");
    const successModal = document.getElementById("newsletterSuccess");

    if (!submitBtn || !consentCheckbox || !emailInput) {
        return;
    }

    const validateForm = function () {
        const isEmailValid = emailInput.value.trim() !== "" && emailInput.checkValidity();
        const isConsentChecked = consentCheckbox.checked;

        submitBtn.disabled = !(isEmailValid && isConsentChecked);

        if (!isEmailValid && !isConsentChecked) {
            submitBtn.title = "Enter email and accept consent";
        } else if (!isEmailValid) {
            submitBtn.title = "Enter a valid email address";
        } else if (!isConsentChecked) {
            submitBtn.title = "Accept personal data processing consent";
        } else {
            submitBtn.title = "Subscribe";
        }
    };

    emailInput.addEventListener("input", validateForm);
    consentCheckbox.addEventListener("change", validateForm);

    form.addEventListener("submit", function (e) {
        const publicValidation = window.PublicFormValidation;
        const isEmailValid = emailInput.value.trim() !== "" && emailInput.checkValidity();
        const isConsentValid = publicValidation && typeof publicValidation.validateConsentCheckbox === "function"
            ? publicValidation.validateConsentCheckbox(consentCheckbox, {
                findErrorContainer: (checkbox) => checkbox?.closest(".newsletter__consent") || null
            })
            : consentCheckbox.checked;
        const isFormValid = publicValidation && typeof publicValidation.validateForm === "function"
            ? (publicValidation.validateForm(form) && isEmailValid)
            : isEmailValid;

        if (!isFormValid || !isConsentValid) {
            e.preventDefault();
            if (!isFormValid) {
                form.classList.add("was-validated");
                emailInput.classList.add("is-invalid");
            } else {
                emailInput.classList.remove("is-invalid");
            }

            if (!isConsentValid) {
                consentCheckbox.classList.add("is-invalid");
            } else {
                consentCheckbox.classList.remove("is-invalid");
            }
            return;
        }

        if (publicValidation && typeof publicValidation.clearConsentValidation === "function") {
            publicValidation.clearConsentValidation(consentCheckbox, {
                findErrorContainer: (checkbox) => checkbox?.closest(".newsletter__consent") || null
            });
        }

        emailInput.classList.remove("is-invalid");
        consentCheckbox.classList.remove("is-invalid");
    });

    if (closeBtn && successModal) {
        closeBtn.addEventListener("click", function () {
            successModal.style.display = "none";
        });
    }

    validateForm();
});
